export const barChartHorizontalI18NPl = {
    projectName: "Nazwa projektu",
    username: "Użytkownik",
    time: "Czas",
};
